/**
 * Array mappings of all projects I've done including their meta-data
 */
// project screenshot imports
import React from 'react';

import scribeeImage from '../../../assets/ScribeeImage.png';
import personalWebsiteImage from '../../../assets/Background.jpg';
import ytUnbiasedImage from '../../../assets/YoutubeUnbiased.jpg';
import upbankImage from '../../../assets/Upbank.jpg'
import personalBlogImage from '../../../assets/PersonalBlog.png';

// uni project photo imports
import comp6441UNSWLogo from '../../../assets/Comp6441Image.png';
import tcpLogo from '../../../assets/TCP.png';
import bigBrainLogo from '../../../assets/Bigbrain.png';
import messagingLogo from '../../../assets/MessagingServer.png';
import taskMasterLogo from '../../../assets/TaskMaster.png';
import dungeonLogo from '../../../assets/DungeonProject.png';

// icons import 
import { 
  SiJavascript,
  SiTypescript,
  SiReact,
  SiRedux,
  SiStyledcomponents,
  SiBootstrap,
  SiMaterialui,
  SiFigma,
  SiAmazonaws,
  SiGooglechrome,
  SiGatsby,
  SiPython,
  SiFlask,
  SiDjango,
  SiJava,
} from "react-icons/si";
  
import {
  IoLogoVercel
} from 'react-icons/io5'

export const projectList = [
  {
    title: 'Scribee',
    description: 'A note taking and management tool that allows users to better manage how they work.',
    technologies: [<SiReact />, <SiTypescript />, <SiBootstrap />, <SiStyledcomponents />, <SiRedux />, <SiAmazonaws />],
    link: '/blog/scribee',
    image: scribeeImage
  },
  {
    title: 'Personal Website',
    description: 'The website that you are on right now! It\'s the hub for all of my work.',
    technologies: [<SiReact />, <SiJavascript />, <SiMaterialui />, <SiGatsby /> , <IoLogoVercel />, <SiFigma />],
    link: '/contact',
    image: personalWebsiteImage
  },
  {
    title: 'Personal Blog',
    description: 'My place on the net where I can talk about random things!',
    technologies: [<SiReact />, <SiJavascript />, <SiMaterialui />,<SiGatsby />, <IoLogoVercel />],
    link: '/blog/hello-world',
    image: personalBlogImage
  },
  {
    title: 'Youtube Unbiased',
    description: 'A chrome extension that reduces influence on the user when watching youtube videos.',
    technologies: [<SiJavascript />, <SiGooglechrome />],
    link: 'https://unbiased.johndao.dev',
    image: ytUnbiasedImage
  },
  {
    title: 'Up Bank Web App',
    description: 'An app that allows UP Bank users to monitor their finances through the web.',
    technologies: [<SiReact />, <SiJavascript />, <SiAmazonaws />],
    link: 'https://upbank.johndao.dev',
    image: upbankImage
  },
]

export const UniProjectsList = [
  {
    title: 'Task Master',
    description: 'A task management and workload distribution system completed for the COMP3900 Capstone Project.',
    technologies: [<SiDjango />, <SiPython />],
    link: '/blog/task-master',
    image: taskMasterLogo
  },
  {
    title: 'Big Brain',
    description: 'A web application that allows users to create, update and run quizzes.',
    technologies: [<SiReact />, <SiBootstrap />],
    link: 'https://github.com/jnddao/uni/tree/main/comp6080/ass3',
    image: bigBrainLogo
  },
  {
    title: 'TCP Custom Protocol Server',
    description: 'TCP based programs that simulates communication between client and server to perform chat room services.',
    technologies: [<SiPython />],
    link: 'https://github.com/jnddao/uni/blob/main/comp3331/ass/report.pdf',
    image: tcpLogo
  },
  {
    title: 'Dungeon Crawler',
    description: 'A dungeon adventure maze game built with Java and JavaFX.',
    technologies: [<SiJava />],
    link: 'https://github.com/jnddao/uni/tree/main/comp2511/H17B-nuoc_mam',
    image: dungeonLogo
  },
  {
    title: 'Security Scripts',
    description: 'A compilation of scripts written for specific security concepts learnt throughout COMP6441.',
    technologies: [<SiPython />],
    link: 'https://github.com/jnddao/comp6441-scripts',
    image: comp6441UNSWLogo
  },
  {
    title: 'Messaging server',
    description: 'A Flask based backend server that allows users to have a personalised profile, and send messages to peers.',
    technologies: [<SiPython />, <SiFlask />],
    link: 'https://github.com/jnddao/uni/tree/main/comp1531/T15A-Honda_Lion',
    image: messagingLogo
  },
]
